import { render } from "./STDSCM01C02Login.vue?vue&type=template&id=b92e4c8c&scoped=true"
import script from "./STDSCM01C02Login.vue?vue&type=script&lang=js"
export * from "./STDSCM01C02Login.vue?vue&type=script&lang=js"

import "./STDSCM01C02Login.vue?vue&type=style&index=0&id=b92e4c8c&scoped=true&lang=css"

import exportComponent from "D:\\TDS\\40_製造(M)\\99_電帳法_USE\\Tatsuzin_filemanage\\vue\\tdsvue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b92e4c8c"]])

export default __exports__